var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offset-3 col-6 notfound"},[_c('h1',[_vm._v("Sivua ei löytynyt")])])
}]

export { render, staticRenderFns }